<fa-duotone-icon [icon]="['fad', 'question-circle']" [size]="size"
                 primaryColor="#03A981" secondaryColor="#3f51b5" secondaryOpacity="1"></fa-duotone-icon>
